import React, { Component } from 'react';
import Header from '../component/header/header';
import GuideTitle from '../component/guide/guideTitle';
import '../component/guide/guide.css';
import { Link } from 'react-router-dom';

class Guide03 extends Component {
    state = {
        checkboxValue: false,
        popupClass: false
    };

    handleChange = (event) => {
        const checkboxValue = this.state.checkboxValue;
        this.setState({checkboxValue: !checkboxValue});
        // console.log(`checkboxValue: ${checkboxValue}`);
    };

    handleNextPage = (event) => {
        event.preventDefault();
        
        if(this.state.checkboxValue === true) {
            window.location="/guide04";
        }else {
            // const popupClass = this.state.popupClass;
            this.setState({popupClass: true});
        }
    };
    
    handleClose = () => {
        // const popupClass = this.state.popupClass;
        this.setState({popupClass: false});
    };
    
    render() {
        const {prePath} = this.props.guide;
        return (
            <div className="gudie-wrap confirm-wrap d-flex flex-column">
                <article className="header-wrap"><Header /></article>
                <form onSubmit={this.handleNextPage}>
                    <section className="main-container d-flex flex-column">
                        <GuideTitle guide={this.props.guide} />
                        <div className="body d-flex flex-column align-items-center scroll-wrapper">
                            <div className="container sub-title">
                                <p>
                                    <b>시험문제 등에 관한 비밀유지 각서 동의</b><br/>
                                    본인은 컴퓨터시험 응시자로서 시험을 통하여 알게 된 시험 관련 사실, 시험문제 및 그 일부 내용에 대하여 아래와 같은 비밀을 유지할 것을 서약합니다.
                                </p>
                            </div>
                            <ul className="container text-container scroll-wrapper">
                                <li>▶ 본인은 컴퓨터시험 응시자로서 시험을 통하여 알게 된 시험 관련 사실, 시험문제 및 그 일부 내용에 대하여 아래와 같은 비밀을 유지할 것을 서약합니다. 
                                </li>
                                <li>시험 응시 도중 대화, 쪽지, 기록, 낙서, 그림, 녹음 등 어떠한 형태로도 본인 외의 사람이 알 수 있도록 하지 않는다.
                                </li>
                                <li>인터넷을 통하여 시험과 관련된 사항에 대하여 일체 게재하지 않는다.
                                </li>
                                <li>
                                    시험 관련 내용을 출판물 또는 그 유사한 형태로 제작하거나 배포 또는 판매하지 않는다.
                                </li>
                                <li>
                                    본인 외의 사람이 알 수 있도록 하여 본인 외의 사람으로 하여금 위 1항 내지 3항을 위반하지 않는다.
                                </li>
                                <li>위 조항을 위반하여 한국보건의료인국가시험원의 업무를 방해하거나, 저작권 침해 또는 부정행위를 한 사실 등이 확인된 경우 부정행위차로 처리되며, 민사 및 형사상 책임이 있음을 인정한다.</li>
                            </ul>

                            <div className="check-box-wrap d-flex align-items-center">
                                <input type="checkbox" id="check" checked={this.state.checkboxValue} onChange={this.handleChange} />
                                <label htmlFor="check">유의사항을 확인하였습니다. (필수)</label>
                            </div>
                        </div>
                    </section>

                    <footer className="footer-wrap w-100 d-flex justify-content-center align-items-center">
                        <div className="page-btn-wrap d-flex justify-content-center align-content-center">
                            <Link to={prePath}>
                                <button className="btn pre-btn">
                                    <span className="icon-wrap">
                                        <svg className="icon pre-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                        </svg>
                                    </span>
                                    <b>이전</b>
                                </button>
                            </Link>
                            <div className="page-info"><span className="current-page">3</span>&nbsp;/&nbsp;<span className="total-page">5</span></div>
                            <button type="submit" className="btn next-btn">
                                <b>다음</b>
                                <span className="icon-wrap">
                                    <svg className="icon next-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </footer>
                </form>

                <section className={this.state.popupClass === true ? "popup-show checkbox-popup popup-wrap" : "d-none"}>
                    <article className="popup-container d-flex flex-column">
                        <p>비밀유지 유의사항 확인을 체크해야 다음 화면으로 넘어갈 수 있습니다.</p>
                        <div><button type="button" className="btn red-btn" onClick={this.handleClose}>확인</button></div>
                    </article>
                </section>

            </div>
        );
    }
}

export default Guide03;